module.exports = __webpack_public_path__ + "static/media/arrow-right.e5a20ee8.svg";